import { Route, Routes } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import FrontPage from "../pages/FrontPage";
import MyProjectsPage from "../pages/MyProjectsPage";
import NotFound from "./NotFound";

function Router()
{
    return (
        <Routes>
            <Route path="/" element={<MainLayout/>}>
                <Route index element={<FrontPage />} />
                {/*TODO<Route path="/about-me" element={<AboutMePage/>}/>*/}
                <Route path="/my-projects" element={<MyProjectsPage />} />
                <Route path="*" element={<NotFound/>} />
            </Route>
        </Routes>
    );
}

export default Router;